import {PageContent} from "@/src/modules/core/components";
import {useStoredCompany} from "@/src/modules/company/store";
import {useStoredMe} from "@/src/modules/core/store/me";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";

import {ResidentHomePillars} from "../components/resident-home-pillars";
import {ResidentHomeAmenityRestrictionBar} from "../components/resident-home-amenity-restriction-bar";
import {ResidentHomeLandlordCard} from "../components/resident-home-landlord-card";
import {ResidentHomeTenantCard} from "../components/resident-home-tenant-card";
import {ResidentHomeWelcomeCard} from "../components/resident-home-welcome-card";

export default function ResidentHome() {
  const me = useStoredMe();
  const userProperty = useStoredUserProperty();
  const company = useStoredCompany();

  const firstName = me?.first_name?.trim() ?? "";
  const supportPhone = company?.support_phone?.trim() || "";

  return (
    <PageContent>
      <div className="flex w-full flex-col gap-3">
        <ResidentHomeAmenityRestrictionBar />
        <ResidentHomeWelcomeCard
          firstName={firstName}
          property={userProperty}
          supportPhone={supportPhone || null}
        />
        <ResidentHomeTenantCard />
        <ResidentHomeLandlordCard />
        <ResidentHomePillars />
      </div>
    </PageContent>
  );
}
